'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxPagan = require('redux-pagan');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _lodash = require('lodash');
var _reactScroll = require('react-scroll');
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _MyStaffUserCard = require('../../components/MyStaffUserCard/MyStaffUserCard');var _MyStaffUserCard2 = _interopRequireDefault(_MyStaffUserCard);
var _myStaff = require('../../redux/modules/myStaff');








var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _components = require('./components');







var _components2 = require('../../components');
var _RealtorLandingPublishFormModal = require('../RealtorLandingPublishForm/RealtorLandingPublishFormModal');var _RealtorLandingPublishFormModal2 = _interopRequireDefault(_RealtorLandingPublishFormModal);


var _MyStaffContainer = require('./MyStaffContainer.scss');var styles = _interopRequireWildcard(_MyStaffContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Styles
var
MyStaffContainer = function (_Component) {_inherits(MyStaffContainer, _Component);
  function MyStaffContainer(props) {_classCallCheck(this, MyStaffContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.




























    getPagination = function (name) {var _this$props =
      _this.props,userToken = _this$props.userToken,myStaff = _this$props.myStaff;
      var filters = Object.assign({},
      myStaff.filter.search_field && { search_field: myStaff.filter.search_field },
      myStaff.filter.search_value && { search_value: myStaff.filter.search_value });

      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          if (selectedPages) {
            _this.setState({ rowsOnPage: selectedPages }, function (state) {
              _this.props.getMyStaff({ token: userToken, params: Object.assign({ $limit: state.rowsOnPage.value }, filters) });
            });
          }
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
        }
      }
      _this.props.getMyStaff({ token: userToken, params: Object.assign({ $limit: 10 }, filters) });
    };_this.

    handleGetMyStaff = function () {var _this$props2 =
      _this.props,userToken = _this$props2.userToken,currentPaginationStep = _this$props2.currentPaginationStep,myStaff = _this$props2.myStaff;var
      value = _this.state.rowsOnPage.value;
      var filters = Object.assign({},
      myStaff.filter.search_field && { search_field: myStaff.filter.search_field },
      myStaff.filter.search_value && { search_value: myStaff.filter.search_value });


      _this.props.getMyStaff({
        token: userToken,
        params: Object.assign({
          $limit: value,
          $skip: currentPaginationStep - 1 },
        filters) });


    };_this.

    scrollToTop = function () {
      if (_this.props.isMobile) {
        setTimeout(function () {return _this.scrollTo();}, 501);
      } else {
        _this.scrollTo();
      }
    };_this.

    scrollTo = function () {var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'anchor-top';var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _reactScroll.scroller.scrollTo(element, Object.assign({
        duration: 500,
        smooth: true,
        offset: -55 },
      options));

    };_this.

    changePagination = function (value) {
      _this.setState({ rowsOnPage: value });
      var serializedVal = JSON.stringify(value);
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('rows-on-my-staff-page', serializedVal);
      }
    };_this.

    handleForward = function () {
      var step = _this.props.currentPaginationStep + _this.state.rowsOnPage.value;
      if (step <= _this.props.myStaff.totalUsersCount) {
        _this.props.setCurrentPaginationStep(step);

        if (document) {
          _this.scrollToTop();
        }
      }
    };_this.

    handleBack = function () {
      var step = _this.props.currentPaginationStep - _this.state.rowsOnPage.value;
      _this.props.setCurrentPaginationStep(step > 1 ? step : 1);
      if (document && step >= 1) {
        _this.scrollToTop();
      }
    };_this.

    handleGoTo = function (val) {
      if (!Number.isNaN(val) && val >= 0) {
        _this.props.setCurrentPaginationStep(val);
        _this.setState({ selected: val });
      }
    };_this.

    closeFormModal = function () {return _this.setState({ isContactModalOpen: false });};_this.
    openFormModal = function () {return _this.setState({ isContactModalOpen: true });};_this.

    closeAddUserFailModal = function () {return _this.setState({ isAddUserFailModal: false });};_this.
    openAddUserFailModal = function () {return _this.setState({ isAddUserFailModal: true });};_this.






















































    renderStaffCard = function () {var _this$props3 =
      _this.props,myStaff = _this$props3.myStaff,translate = _this$props3.translate,isMobile = _this$props3.isMobile;

      return myStaff.data.map(function (item) {return (
          _react2.default.createElement(_MyStaffUserCard2.default, _extends({},
          item, {
            metaStaff: myStaff.meta,
            myStaff: myStaff,
            isMobile: isMobile,
            translate: translate,
            editUser: _this.props.editUser,
            deleteUser: _this.props.deleteUser,
            userToken: _this.props.userToken })));});


    };_this.

    renderContactFormModal = function () {return (
        _react2.default.createElement(_components2.Modal, {
            className: 'publishFormContactUsModal',
            isOpen: _this.state.isContactModalOpen,
            onRequestClose: _this.closeFormModal,
            isRtl: _this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_RealtorLandingPublishFormModal2.default, {
            inModal: true,
            formModalIsOpen: _this.state.isContactModalOpen,
            handleRequest: _this.closeFormModal })));};_this.state = { isContactModalOpen: false, isAddUserFailModal: false, rowsOnPage: { value: 10, label: 10 }, selected: 1 };_this.debouncedGetMyStaff = (0, _lodash.debounce)(_this.handleGetMyStaff, 1000);return _this;}MyStaffContainer.prototype.componentDidMount = function componentDidMount() {this.getPagination('rows-on-my-staff-page');};MyStaffContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (newProps.currentPaginationStep !== this.props.currentPaginationStep) {this.debouncedGetMyStaff();}if (newProps.myStaff.addUserLoaded && newProps.myStaff.addUserLoaded !== this.props.myStaff.addUserLoaded) {newProps.closeAddNewStaffForm();}if (newProps.myStaff.error && newProps.myStaff.error !== this.props.myStaff.error) {this.openAddUserFailModal();newProps.closeAddNewStaffForm();}};MyStaffContainer.prototype.renderPagination = function renderPagination() {var _this2 = this;var _props = this.props,translate = _props.translate,currentPaginationStep = _props.myStaff.currentPaginationStep;var rowsOnPage = this.state.rowsOnPage;var totalUsersCount = this.props.myStaff.totalUsersCount;var nextStart = currentPaginationStep + rowsOnPage.value - 1;var lastProperty = nextStart < totalUsersCount ? nextStart : totalUsersCount;var options = [{ value: 10, label: 10 }, { value: 50, label: 50 }, { value: 100, label: 100 }];var desktopPagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('div', { className: styles.navigateBtn }, _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' }))), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + totalUsersCount), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', null, translate('managePage', 'goTo')), _react2.default.createElement('div', { className: styles.inputWrapper }, _react2.default.createElement('input', { type: 'number', value: this.state.selected, onChange: function onChange(val) {return _this2.handleGoTo(+val.target.value);} }))), _react2.default.createElement('div', { className: styles.inputSection }, _react2.default.createElement('span', { className: styles.showRows }, translate('managePage', 'showRows')), _react2.default.createElement(_reactSelect2.default, { name: 'rows-on-my-staff-page', value: this.state.rowsOnPage, options: options, onChange: this.changePagination, clearable: false, searchable: false })));var mobilePagination = _react2.default.createElement('div', { className: styles.paginationBlock }, _react2.default.createElement('button', { onClick: this.handleForward, className: styles.forwardBtn }, _react2.default.createElement('span', { className: 'icon-back' })), _react2.default.createElement('span', null, currentPaginationStep + '-' + lastProperty + ' ' + translate('managePage', 'of') + ' ' + totalUsersCount), _react2.default.createElement('button', { onClick: this.handleBack, className: styles.backBtn }, _react2.default.createElement('span', { className: 'icon-back' })));return this.props.isMobile ? mobilePagination : desktopPagination;};MyStaffContainer.prototype.




  render = function render() {var _props2 =








    this.props,myStaff = _props2.myStaff,isMobile = _props2.isMobile,translate = _props2.translate,addNewStaffFormOpen = _props2.addNewStaffFormOpen,userProperties = _props2.userProperties,isRtl = _props2.isRtl,userToken = _props2.userToken;

    return (
      _react2.default.createElement('div', { className: styles.pageWrapper },
        _react2.default.createElement(_reactScroll.Element, { name: 'anchor-top' }),
        _react2.default.createElement('p', { className: styles.title }, translate('myStaff', 'title')),
        myStaff.loaded && !myStaff.meta.totalUsersCount && _react2.default.createElement('p', { className: styles.subtitle }, translate('myStaff', 'noLengthStaff')),
        _react2.default.createElement('div', { className: styles.contentWrapper },
          _react2.default.createElement('div', { className: styles.cardWrapper },
            this.renderStaffCard(),

            this.props.myStaff.totalUsersCount > 10 &&
            !!myStaff.data.length &&
            this.renderPagination()),


          _react2.default.createElement('div', { className: styles.controlUnitWrapper },
            _react2.default.createElement(_components.SearchEmployees, {
              translate: translate,
              userToken: userToken,
              getMyStaff: this.props.getMyStaff }),

            !isMobile &&
            _react2.default.createElement(_components.QuickTeamAdd, {
              openAddNewStaffForm: this.props.openAddNewStaffForm,
              translate: translate }),


            !isMobile &&
            _react2.default.createElement(_components.MyPropertiesBlock, {
              isRtl: isRtl,
              userProperties: userProperties,
              openFormModal: this.openFormModal,
              translate: translate,
              metaStaff: myStaff.meta })),



          isMobile &&
          _react2.default.createElement(_components.FooterMyStaff, {
            openAddNewStaffForm: this.props.openAddNewStaffForm,
            translate: translate,
            openFormModal: this.openFormModal,
            userProperties: userProperties,
            metaStaff: myStaff.meta,
            isRtl: isRtl })),



        _react2.default.createElement(_components2.Modal, {
            isOpen: addNewStaffFormOpen,
            className: styles.modal,
            onRequestClose: this.props.closeAddNewStaffForm },

          _react2.default.createElement(_components.AddNewStaffForm, {
            isRtl: isRtl,
            userToken: userToken,
            addUser: this.props.addUser,
            translate: translate,
            addUserLoading: this.props.myStaff.addUserLoading,
            metaStaff: myStaff.meta })),


        _react2.default.createElement(_components.ModalError, {
          isOpen: this.state.isAddUserFailModal,
          translate: translate,
          error: this.props.myStaff.error,
          onRequestClose: this.closeAddUserFailModal }),

        this.renderContactFormModal()));


  };return MyStaffContainer;}(_react.Component);


MyStaffContainer.propTypes = {
  translate: _propTypes2.default.func,
  openAddNewStaffForm: _propTypes2.default.func,
  myStaff: _propTypes2.default.object,
  getMyStaff: _propTypes2.default.func,
  addUser: _propTypes2.default.func,
  closeAddNewStaffForm: _propTypes2.default.func,
  deleteUser: _propTypes2.default.func,
  editUser: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  userProperties: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  addNewStaffFormOpen: _propTypes2.default.bool,
  currentPaginationStep: _propTypes2.default.number,
  isRtl: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    userToken: (0, _lodash.get)(state, 'userAuthentication.data.access_token'),
    isMobile: state.windowDimentions.isMobile,
    userProperties: state.manageProperties,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    addNewStaffFormOpen: state.myStaff.addNewStaffFormOpen,
    myStaff: state.myStaff,
    currentPaginationStep: state.myStaff.currentPaginationStep };};


var mapDispatchToProps = {
  addUser: _myStaff.addUser,
  editUser: _myStaff.editUser,
  getMyStaff: _myStaff.getMyStaff,
  deleteUser: _myStaff.deleteUser,
  openAddNewStaffForm: _myStaff.openAddNewStaffForm,
  closeAddNewStaffForm: _myStaff.closeAddNewStaffForm,
  setCurrentPaginationStep: _myStaff.setCurrentPaginationStep };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
MyStaffContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/MyStaffContainer.js
// module id = 2934
// module chunks = 0